export class RespondreAlegacio {
    exp: string;
    resultat: boolean;
    situacio: string;
    tipo: string;
 }
